// extracted by mini-css-extract-plugin
export default {"checkboxWrapper":"styles__checkboxWrapper___3ArmW","checkboxLabel":"styles__checkboxLabel___5If5M","textAction":"styles__textAction___ZRbA-","actions":"styles__actions___ABnz9"};